import type { MysteryRoomSoundDefinition } from './mapTypes';

/** Шесть стандартных MP3-треков окружения. В рантайме URL из public/games/mystery-room/audio/; исходники держите в Music/ у корня репозитория (копирует scripts/deploy_frontend.py перед деплоем). */
export const MYSTERY_ROOM_STANDARD_AMBIENT_SOUND_DEFINITIONS: MysteryRoomSoundDefinition[] = [
  {
    id: 'ambient_track_1',
    label: 'Фон: трек 1',
    kind: 'ambient',
    url: '/games/mystery-room/audio/3e8e23a0444d43e.mp3',
  },
  {
    id: 'ambient_track_2',
    label: 'Фон: трек 2',
    kind: 'ambient',
    url: '/games/mystery-room/audio/0509cceae472285.mp3',
  },
  {
    id: 'ambient_track_3',
    label: 'Фон: трек 3',
    kind: 'ambient',
    url: '/games/mystery-room/audio/1364abea33a55ed.mp3',
  },
  {
    id: 'ambient_track_4',
    label: 'Фон: трек 4',
    kind: 'ambient',
    url: '/games/mystery-room/audio/c1b4eb9ba152e29.mp3',
  },
  {
    id: 'ambient_track_5',
    label: 'Фон: трек 5',
    kind: 'ambient',
    url: '/games/mystery-room/audio/c65bf2341606cb9.mp3',
  },
  {
    id: 'ambient_track_6',
    label: 'Фон: трек 6',
    kind: 'ambient',
    url: '/games/mystery-room/audio/cb0e49d47834e5c.mp3',
  },
];

export const MYSTERY_ROOM_STANDARD_AMBIENT_TRACK_IDS = MYSTERY_ROOM_STANDARD_AMBIENT_SOUND_DEFINITIONS.map((d) => d.id);

/** Устойчивый выбор одного из шести треков для замены синтезированного окружения. */
export function mysteryRoomPickStandardAmbientTrackId(seed: string): string {
  let h = 0;
  for (let i = 0; i < seed.length; i += 1) {
    h = (Math.imul(31, h) + seed.charCodeAt(i)) | 0;
  }
  const idx = Math.abs(h) % MYSTERY_ROOM_STANDARD_AMBIENT_TRACK_IDS.length;
  return MYSTERY_ROOM_STANDARD_AMBIENT_TRACK_IDS[idx] ?? 'ambient_track_1';
}

export function mergeStandardAmbientSoundDefinitions(existing: MysteryRoomSoundDefinition[]): MysteryRoomSoundDefinition[] {
  const byId = new Map(existing.map((d) => [d.id, { ...d }]));
  for (const def of MYSTERY_ROOM_STANDARD_AMBIENT_SOUND_DEFINITIONS) {
    if (!byId.has(def.id)) {
      byId.set(def.id, { ...def });
    }
  }
  return Array.from(byId.values());
}
